module.exports = __webpack_public_path__ + "841a4fa3f4a13e4448f36e0dd4552675.png";